import { axios } from '../request'

export default (_app) => {
  const url = 'pdf_documents'

  return {
    namespaced: true,
    state: {
      listById: {},
      list: [{}],
      loading: false,
      loaded: false,
      errors: [],
      uploading: false,
      uploadingPerFile: [],
      progress: 0, // upload progress
      perFileProgress: [],
    },
    mutations: {
      clearList(state) {
        state.list = [{}]
        state.perFileProgress = []
      },
      setSingle(state, { key, data }) {
        state.list[key] = data
        state.listById[data._id] = data
      },
      setErrors(state, { key, payload }) {
        if (typeof payload !== 'undefined') {
          state.errors[key] = payload
        }
      },
      setLastStatus(state, s) {
        state.status = s
      },
      clearErrors(state) {
        state.errors = []
      },
      loading(state) {
        Object.assign(state, { loaded: false, loading: true })
      },
      loaded(state) {
        Object.assign(state, { loaded: true, loading: false })
      },
      notLoaded(state) {
        Object.assign(state, { loaded: false, loading: false })
      },
      removeFromList(state, k) {
        state.list.splice(k, 1)
        if (state.list.length === 0) {
          state.list = [{}]
        }
      },
      setUploading(state, { key, value }) {
        state.uploadingPerFile[key] = value
        const uploadingItem = state.uploadingPerFile.find((u) => {
          return u
        })
        if (typeof uploadingItem !== 'undefined') {
          state.uploading = true
        } else {
          state.uploading = false
        }
      },
      setProgress(state, { key, value }) {
        state.perFileProgress[key] = value
        let sum = 0
        state.perFileProgress.forEach((fp) => {
          sum += fp
        })
        state.progress = sum / state.perFileProgress.length
      },
    },
    actions: {
      clearList(context) {
        context.commit('clearList')
      },
      readFrom(context, data) {
        return new Promise((resolve, reject) => {
          const key = 0
          context.commit('setErrors', { key, payload: {} })
          context.commit('notLoaded')
          context.commit('loading')
          axios
            .get(data.resource + '/' + data.id + '/member_photos')
            .then((res) => {
              context.commit('clearErrors')
              context.commit('setSingle', { key, data: res.data.data })
              context.commit('loaded')
              context.commit('setLastStatus', res.status)
            })
            .catch((err) => {
              context.commit('clearErrors')
              context.commit('setSingle', { key, data: {} })
              if (err.response) {
                context.commit('setLastStatus', err.response.status)
                if (err.response.status === 404) {
                  context.commit('loaded')
                } else {
                  context.commit('notLoaded')
                }
              } else {
                context.commit('notLoaded')
              }
              reject(new Error('Could not read item'))
            })
        })
      },
      delete(context, k) {
        return new Promise((resolve, reject) => {
          const id = context.state.list[k]._id
          if (typeof id !== 'undefined') {
            axios
              .delete(`${url}/${id}`)
              .then(() => {
                context.commit('removeFromList', k)
                resolve()
              })
              .catch(() => {
                reject(new Error('failed to delete'))
              })
          } else {
            context.commit('removeFromList', k)
            resolve()
          }
        })
      },
      upload(context, { data, key }) {
        return new Promise((resolve, reject) => {
          const headers = { 'Content-Type': 'multipart/form-data' }
          context.commit('setUploading', { key, value: true })
          axios
            .post(url, data, {
              headers: headers,
              timeout: 0,
              onUploadProgress(progressEvent) {
                context.commit('setProgress', {
                  key: key,
                  value: (progressEvent.loaded / progressEvent.total) * 100,
                })
              },
            })
            .then((res) => {
              context.commit('setUploading', { key, value: false })
              resolve(res.data.data)
            })
            .catch((err) => {
              context.commit('setUploading', { key, value: false })
              // Reject with the axios error itself so the caller still has the
              // status and the server's validation body. Replacing it with a
              // string of our own threw away a perfectly good "File is in a
              // invalid format" and left the user with nothing (#334).
              reject(err)
            })
        })
      },
    },
  }
}
